import React from 'react';
import { Link } from "react-router-dom";
import { FaBookOpen, FaChevronRight, FaCode, FaUsers } from 'react-icons/fa';
import { HomeTechArticles } from './home_ai.jsx';
import MySlider from '../MySlider';
import Home_cards from '../content/home_cards';

export default function HomeContentSections({
  glassPanel,
  systemComponentsTitle,
  techStackItems,
  main_domain,
  latest_version,
  digitalSuiteArticles = [],
  digitalSuiteTotal = null,
}) {
  const showHello =
    main_domain == 'hust' &&
    latest_version &&
    latest_version != 1 &&
    latest_version != '1';

  const showSlider = latest_version == 1 || latest_version == '1';

  const reactStyleLinks = [
    {
      key: 'learn',
      title: 'Learn',
      label: 'Documentation',
      description: 'Guides and overviews to get started quickly.',
      to: '/next/docs/overview',
      reloadDocument: true,
      Icon: FaBookOpen,
    },
    {
      key: 'api',
      title: 'API',
      label: 'Reference',
      description: 'Explore tools, modules, and integration points.',
      to: '/ai/utility/home_ai',
      Icon: FaCode,
    },
    {
      key: 'community',
      title: 'Community',
      label: 'Channel',
      description: 'Follow updates and discussions in one place.',
      to: '/shop/channel?showadview=true',
      Icon: FaUsers,
    },
  ];

  return (
    <>
      {showHello && (
        <HomeTechArticles
          glassPanel={glassPanel}
          latest_version={latest_version}
          digitalSuiteArticles={digitalSuiteArticles}
          digitalSuiteTotal={digitalSuiteTotal}
        />
      )}
      {!showHello && (
        <>
          {/* LƯU Ý: Đảm bảo trong Home_cards (value="benefits") không có chữ "Unlimited Free" hay "Web 3.0". Nếu có thì bot sẽ vẫn bắt lỗi. */}
          <Home_cards value="benefits" />

          {/* CORE STACK */}
          <Home_cards
            value="tech_stack"
            title={systemComponentsTitle}
            items={techStackItems}
            className="enter-stack"
          />
        </>
      )}
      {/* SLIDER (only for v1) */}
      {showSlider ? (
        <div className={`${glassPanel} enter-slider py-2 sm:py-3`}>
          <MySlider />
        </div>
      ) : null}
    </>
  );
}
